import * as amplitude from '@amplitude/analytics-browser';
import whenDomReady from 'when-dom-ready';
const COOKIE_NAME = 'CookieControl';
const Events = {
    LEARN_HOME_VISIT: 'visit learn home page',
    LEARN_SECTION_VISIT: 'visit learn section',
    LEARN_RESOURCE_VISIT: 'visit learn resource',
};
const Properties = {
    EMPLOYER_SPECIFIC: 'learn url employer name',
};
function initialise() {
    if (window.AmpConfig && !window.AmpConfig.cookiePolicyEnabled) {
        initTracking();
    }
    else {
        initCookieListener();
    }
}
/**
 * Check whether the necessary cookie has been accepted or not, initialise based on the result.
 * If permissions cookie doesn't exist, loop until it's been configured.
 */
function initCookieListener() {
    const cookieAccepted = getCookiePolicyValue();
    if (cookieAccepted === null) {
        return document.addEventListener('analytical-cookies-accepted', () => {
            initTracking();
        });
    }
    else if (cookieAccepted === true) {
        return initTracking();
    }
    else {
        return;
    }
}
function initTracking() {
    amplitude
        .init(window.AmpConfig.apiKey, undefined, {
        serverZone: amplitude.Types.ServerZone.EU,
    })
        .promise.then(() => {
        initHomepageVisit();
        initLearnSectionVisit();
        initLearnResourceVisit();
    });
}
/** Check if user visited the homepage, and get employer if applicable */
function initHomepageVisit() {
    const homepageCheck = document.querySelector('.js-learn-home-identifier');
    if (homepageCheck) {
        const initialPathnameArray = window.location.pathname.split('/').filter(item => item != '');
        if (initialPathnameArray.length > 1) {
            const employer = initialPathnameArray[0].toUpperCase();
            const homepageIdentify = new amplitude.Identify();
            homepageIdentify.set(Properties.EMPLOYER_SPECIFIC, employer);
            amplitude.identify(homepageIdentify);
        }
        amplitude.track(Events.LEARN_HOME_VISIT);
    }
}
/** Check if user visited a Learn Section/Category */
function initLearnSectionVisit() {
    const learnSectionCheck = document.querySelector('.js-learn-section-identifier');
    if (learnSectionCheck) {
        const initialPathnameArray = window.location.pathname.split('/').filter(item => item != '');
        const section = initialPathnameArray.pop()?.toUpperCase();
        if (initialPathnameArray.length > 1) {
            const employer = initialPathnameArray[0].toUpperCase();
            const sectionIdentify = new amplitude.Identify();
            sectionIdentify.set(Properties.EMPLOYER_SPECIFIC, employer);
            amplitude.identify(sectionIdentify);
        }
        amplitude.track(Events.LEARN_SECTION_VISIT, {
            sectionName: section,
        });
    }
}
/** Check if user visited a Learn Resource */
function initLearnResourceVisit() {
    const learnResourceCheck = document.querySelector('.js-learn-resource-identifier');
    if (learnResourceCheck) {
        const initialPathnameArray = window.location.pathname.split('/').filter(item => item != '');
        const resource = initialPathnameArray.pop()?.toUpperCase();
        if (initialPathnameArray.length > 2) {
            const employer = initialPathnameArray[0].toUpperCase();
            const resourceIdentify = new amplitude.Identify();
            resourceIdentify.set(Properties.EMPLOYER_SPECIFIC, employer);
            amplitude.identify(resourceIdentify);
        }
        amplitude.track(Events.LEARN_RESOURCE_VISIT, {
            resourceName: resource,
        });
    }
}
/** Get cookie policy cookie values, return the result of optionalAnalytics policy  */
function getCookiePolicyValue() {
    const policy = getCookie(COOKIE_NAME);
    if (policy === '') {
        return null;
    }
    if (JSON.parse(policy)?.optionalCookies?.optionalAnalytics === 'accepted') {
        return true;
    }
    else {
        return false;
    }
}
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts !== undefined && parts.length === 2) {
        return parts
            ?.pop()
            ?.split(';')
            .shift();
    }
    else {
        return '';
    }
}
whenDomReady().then(initialise);
